import React, {
  useState,
  useContext,
  useEffect,
  useMemo,
  useCallback,
} from 'react'
import {
  DatePicker,
  Table,
  Button,
  Input,
  Modal,
  Icon,
  Popconfirm,
  message,
} from 'antd'
import {
  deleteErrorLogTrace,
  getErrorTraceLogList,
  getErrorTraceLogblob,
  getSystemConfigurationInfo,
} from 'api/pgads'
import { connect } from 'react-redux'
import moment from 'moment'
import { getApiTargetInfo } from 'core'
import { ErrorContext, SpinContext } from 'context'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Title,
} from 'core/screen-util'
import { useLocation } from 'react-router-dom'
const Column = getBlobTask => [
  {
    title: 'Error ID',
    dataIndex: 'id',
    width: 200,
  },
  {
    title: 'User',
    dataIndex: 'user',
    width: 150,
  },

  {
    title: 'Error Date',
    dataIndex: 'modDate',
    width: 150,
    render: text => moment(text).format('MM/DD/YYYY HH:mm:ss'),
  },

  {
    title: 'Error Trace',
    dataIndex: 'available',
    width: 150,
    render: text => (
      <span>
        <Icon
          style={{ marginRight: `5px`, cursor: `pointer` }}
          theme="twoTone"
          type={
            text !== undefined && text.startsWith('1:') ? 'file-text' : 'file'
          }
          onClick={() => getBlobTask(text.substring(2))}
          key="request_blob"
        />
        {text !== undefined && text.startsWith('1:') ? 'BLOB' : 'N/A'}
      </span>
    ),
  },
  // {
  //   title: 'Modifier',
  //   dataIndex: 'modifier',
  // },
]

const ErrorTraceLogScreen = props => {
  const { targetInfo, showDelete = true } = props
  const { setError } = useContext(ErrorContext)

  const getBlobTask = useCallback(
    id => {
      getErrorTraceLogblob(targetInfo)({ id }).fork(setError, res => {
        setModal(true)
        setBlob(res)
      })
    },
    [setError, targetInfo]
  )

  // const getQuery = _ => {
  //   const { search } = useLocation()

  //   const params = React.useMemo(() => new URLSearchParams(search), [search])

  //   // if (params.get('id')) getBlobTask(params.get('id'))

  //   return { date: params.get('date'), id: params.get('id') }
  // }

  const { search } = useLocation()

  const params = useMemo(() => new URLSearchParams(search), [search])

  useEffect(
    _ => {
      if (params.get('id')) getBlobTask(params.get('id'))
    },
    [getBlobTask, params]
  )

  const [data, setData] = useState(null)
  const [selectedDate, setSelectedDate] = useState(
    // queryParams.date ? moment(queryParams.date) : moment()
    moment().date(1)
  )

  const [sysDeleteDate, setSysDeleteDate] = useState(120)
  useEffect(
    _ => {
      getSystemConfigurationInfo(targetInfo).fork(setError, list => {
        const daygap = list.find(
          s => s.key === 'DELETE_ERROR_TRACE_PAST_DAYS'
        ) || { value: 120 }
        setSysDeleteDate(daygap.value)
      })
    },
    [setError, targetInfo]
  )
  useEffect(_ => setData([]), [selectedDate, setSelectedDate])
  const [modal, setModal] = useState(false)
  const [blob, setBlob] = useState(null)

  const [filter, setFilter] = useState('')
  const { setSpinning } = useContext(SpinContext)
  const retrieveTask = ({ date = selectedDate }) => {
    setSpinning(true)

    getErrorTraceLogList(targetInfo)(date).fork(setError, data => {
      setSpinning(false)
      setData(data)
    })
  }

  const filteredData = (data, filterText) => {
    return (
      data &&
      data.filter(d => {
        if (filterText.trim().length <= 0) return true
        return (
          (d.user && d.user.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.id && d.id.toLowerCase().includes(filterText.toLowerCase())) ||
          (d.modDate &&
            moment(d.modDate)
              .format('MM/DD/YYYY HH:mm:ss')
              .toLowerCase()
              .includes(filterText.toLowerCase()))
        )
        // (d.serviceName && d.serviceName.startsWith(filterText)) ||
        // (d.transId && d.transId.includes(filterText))
      })
    )
  }
  const confirm = _ => {
    deleteErrorLogTrace(targetInfo).fork(setError, _ => {
      setSpinning(false)
      message.info('Log Deleted.')
    })
  }

  return (
    <div>
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          Error Stacktrace Log
        </Title>
        {/* <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        /> */}
        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />
        <Button
          style={{ marginLeft: '10px' }}
          type="primary"
          onClick={_ => retrieveTask({})}
        >
          Retrieve
        </Button>
        <Filler />
        <Input.Search
          placeholder="Filter"
          style={{ marginLeft: '10px', width: 200 }}
          onChange={e => setFilter(e.target.value)}
        />
        {showDelete && (
          <Popconfirm
            title={
              <div>
                <div>Are you sure delete this task?</div>
                <div>
                  This will delete Error log prior to {sysDeleteDate} days ago.
                </div>
              </div>
            }
            onConfirm={confirm}
            // onCancel={cancel}
            okText="Confirm"
            cancelText="Cancel"
          >
            <Button type="danger" style={{ marginLeft: 20 }}>
              Clear Error Log
            </Button>
          </Popconfirm>
        )}
        <Modal
          maskClosable
          title="Error Trace"
          visible={modal}
          onOk={() => setModal(false)}
          onCancel={() => setModal(false)}
          destroyOnClose
          closable
          footer={
            <div>
              {window.navigator.clipboard && (
                <Button
                  icon="copy"
                  theme="twoTone"
                  type="dashed"
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                  onClick={() => {
                    window.navigator.clipboard &&
                      window.navigator.clipboard
                        .writeText(blob)
                        .then(() => {
                          message.info('Data Copied.')
                        })
                        .catch(e => console.log(e))
                        .finally(_ => setModal(false))
                  }}
                >
                  Copy & Close
                </Button>
              )}
              <Button type="primary" onClick={() => setModal(false)}>
                Close
              </Button>
            </div>
          }
          width={900}
          left={20}
        >
          <div
            style={{
              maxHeight: '600px',
              width: '870px',
              display: 'grid',
              gridTemplateColumns: '1fr',
              overflowX: 'auto',
            }}
          >
            <Input.TextArea autosize value={blob} />
          </div>
        </Modal>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200}>
        {({ height }) => (
          <Content style={{ height, padding: '10px' }}>
            <div>
              <Table
                className="tableifw"
                columns={Column(getBlobTask)}
                dataSource={filteredData(data, filter)}
                bordered
                pagination={false}
                scroll={{ y: height - 70 }}
                size="small"
                rowKey={e => e.id}
              />
            </div>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(ErrorTraceLogScreen)
